<app-header></app-header>
<div class="container">    
    <div class="row">
        <div class="col-md-6">
            <footer>
                <img class="footer" src="assets/Image1.webp">
            </footer>
        </div>
        <div class="col-md-6" style="align-content: space-around;">
            <div class="card">
                <div class="card-header common">
                    Welcome to AHC
                </div>
                <div class="card-body">
                    <div class="login-form">
                        <form [formGroup]="validationForm">
                            <label class="font-weight-bold">Your Company Name*</label>
                            <input type="text" class="form-control mb-2" formControlName="companyName">
                            <label class="font-weight-bold">Corporte Email Id*</label>
                            <input type="text" class="form-control mb-2" formControlName="email">
                            <label class="font-weight-bold">Employee Code*</label>
                            <input type="text" class="form-control mb-2" formControlName="employeeCode">
                            <ng-container *ngIf="error"><label class="font-weight-bold text-danger">{{ error }}</label></ng-container>
                            <div class="d-flex justify-content-around mt-2">
                                <button class="btn btn-primary common" [disabled]="validationForm.invalid" (click)="validateUser()">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>